// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__N0X2u","rootSuccess":"CompleteLink_rootSuccess__2PSqB","rootFailure":"CompleteLink_rootFailure__2yMKJ","isDisabled":"CompleteLink_isDisabled__1x-KF"};